import ObjectTypes from './object-types';
import scrollTo from './scrollTo';

export default {
  description: {
    type: ObjectTypes.String,
    warning: 'A description is required.',
    progressValue: 1,
    scrollTo: () => scrollTo.scrollToFunc('#profile-description'),
  },
  phone: {
    type: ObjectTypes.String,
    warning: 'A phone is required.',
    progressValue: 1,
    scrollTo: () => scrollTo.scrollToFunc('#phone'),
  },
  address: {
    type: ObjectTypes.Address,
    warning: 'An address is required.',
    progressValue: 3,
    scrollTo: () => scrollTo.scrollToFunc('#address'),
  },
  rating: {
    type: ObjectTypes.Rating,
    warning: 'A rating is required.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: () => scrollTo.scrollToFunc('#rating'),
  },
  contacts: {
    type: ObjectTypes.LocationContact,
    warning: 'At least 1 contact is required.',
    progressValue: 1,
    scrollTo: () => scrollTo.scrollToFunc('#contactsNode'),
  },
  isProductMarketingReady: {
    type: ObjectTypes.Exact.bind(ObjectTypes.Exact, true),
    warning: 'At least 1 complete product is required.',
    progressValue: 3,
    scrollTo: () => scrollTo.scrollToFunc('#prodAnchor'),
  },
  amenities: {
    type: ObjectTypes.Array,
    warning: 'You must select at least 1 amenity.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: () => scrollTo.scrollToFunc('#amenity'),
  },
  companyTypes: {
    type: ObjectTypes.Array,
    warning: 'You must select at least 1 company type.',
    progressValue: 1,
    scrollTo: () => scrollTo.scrollToFunc('#companyTypes'),
  },
  marketSegments: {
    type: ObjectTypes.Array,
    warning: 'At least 1 Market Segment is required.',
    progressValue: 1,
    scrollTo: () => scrollTo.scrollToFunc('#marketSegments'),
  },
};



// WEBPACK FOOTER //
// ./src/app/utils/marketing-readiness/location.js